if (document.querySelector(".animate-text")) {
  const { children: titles } = document.querySelector(".animate-text");

  const txtsLen = titles.length;
  let index = 0;
  const textInTimer = 3700;
  const textOutTimer = 3300;

  function animateText() {
    for (let i = 0; i < txtsLen; i++) {
      titles[i].classList.remove("text-in", "text-out");
    }
    titles[index].classList.add("text-in");

    setTimeout(function () {
      titles[index].classList.add("text-out");
    }, textOutTimer);

    setTimeout(function () {
      if (index == txtsLen - 1) {
        index = 0;
      } else {
        index++;
      }
      animateText();
    }, textInTimer);
  }

  window.onload = animateText;
}
